export default __webpack_public_path__ + "static/media/Vector.b2bc6068.svg";